/**
 * Departments Module
 */
(function(){
    'use strict';

    angular.module('elogbooks.admin.departments', []);
})();